import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { first } from "rxjs/operators";
import { RuleDao } from "../../core/model/rule-dto";
import { RuleService } from "../../core/service/rule.service";

@Component({
  selector: "app-edit-rule-engine",
  templateUrl: "./edit-rule-engine.component.html",
  styleUrls: ["./edit-rule-engine.component.scss"],
})
export class EditRuleEngineComponent implements OnInit {
  editorOptions = { theme: "vs-dark", language: "javascript" };

  @Input()
  set rule(value: RuleDao) {
    if (value) {
      this._rule = { ...value };
      this.cdr.detectChanges();
    }
  }
  get rule(): RuleDao {
    return this._rule;
  }

  private _rule: RuleDao;
  form2: FormGroup;
  pressButton: Boolean = false;
  loading = false;

  constructor(
    private _ruleService: RuleService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      ruleNamespace: [null, Validators.compose([Validators.required])],
      condition: [null, Validators.compose([Validators.required])],
      action: [null, Validators.compose([Validators.required])],
      priority: [null, Validators.compose([Validators.required])],
      description: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this._ruleService
      .update(this.rule)
      .pipe(first())
      .subscribe(
        () => {
          this.pressButton = false;
          this.activeModal.close(this.rule);
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
